import { styled } from "@mui/material";
import { loginLayoutName } from "../classes.js";
const doNotForward = ["ownerState", "hide"];
const RightColumn = styled("div", {
  name: loginLayoutName,
  slot: "RightColumn",
  overridesResolver: (_, styles) => styles.rightColumn,
  shouldForwardProp: (prop) => !doNotForward.includes(prop)
})(({ hide, theme }) => ({
  flex: "1 1 66%",
  height: "100%",
  overflow: "hidden",
  ...hide && {
    display: "none"
  },
  [theme.breakpoints.down("md")]: {
    display: "none"
  }
}));
export {
  RightColumn
};
//# sourceMappingURL=RightColumn.js.map
